import { Stack, Link } from "expo-router";
import { ScrollView, StyleSheet, View } from "react-native";
import { Text } from "react-native-paper";

const sections = [
  {
    title: "取得する情報",
    body: [
      "アカウント登録時のメールアドレス、表示名、認証に必要な情報",
      "ユーザーが投稿する学習記録、画像、公開範囲、関連する学問カード情報",
      "アプリの安定運用に必要な端末情報、利用状況、エラーログ等",
    ],
  },
  {
    title: "利用目的",
    body: [
      "学習記録、教材ライブラリ、投稿共有、プロフィール等の機能を提供するため",
      "本人確認、不正利用防止、問い合わせ対応、障害調査を行うため",
      "サービスの品質改善、機能改善、利用状況の分析を行うため",
    ],
  },
  {
    title: "第三者提供",
    body: [
      "法令に基づく場合を除き、本人の同意なく個人情報を第三者に提供しません。",
      "アプリの提供に必要な範囲で、クラウドサービスや認証基盤などの外部サービスを利用することがあります。",
    ],
  },
  {
    title: "外部サービス",
    body: [
      "本アプリでは、認証、データ保存、画像保存等のために Supabase を利用します。",
      "ストア配信、クラッシュ解析、OS 標準機能等により、Apple または Google が定める範囲で情報が処理される場合があります。",
    ],
  },
  {
    title: "写真ライブラリの利用",
    body: [
      "ユーザーが投稿やプロフィールに画像を添付する場合に限り、写真ライブラリへのアクセスを求めます。",
      "ユーザーが選択していない写真を、アプリが自動で取得または送信することはありません。",
    ],
  },
  {
    title: "情報の管理",
    body: [
      "取得した情報は、漏えい、滅失、改ざん、不正アクセスを防止するため、合理的な安全管理措置を講じます。",
      "ユーザーは、アカウント情報や投稿内容について、アプリ内機能または問い合わせにより確認、修正、削除を求めることができます。",
    ],
  },
];

export default function PrivacyPage() {
  return (
    <>
      <Stack.Screen options={{ title: "プライバシーポリシー" }} />
      <ScrollView style={styles.page} contentContainerStyle={styles.content}>
        <View style={styles.header}>
          <Text style={styles.kicker}>学問レンズ</Text>
          <Text style={styles.title}>プライバシーポリシー</Text>
          <Text style={styles.updated}>最終更新日: 2026年5月27日</Text>
          <Text style={styles.lead}>
            学問レンズは、教育目的で利用される学習アプリとして、ユーザーの個人情報と学習データを適切に取り扱います。
          </Text>
        </View>

        <View style={styles.policy}>
          {sections.map((section, index) => (
            <View key={section.title} style={styles.section}>
              <Text style={styles.sectionTitle}>
                {index + 1}. {section.title}
              </Text>
              {section.body.map((item) => (
                <Text key={item} style={styles.paragraph}>
                  {item}
                </Text>
              ))}
            </View>
          ))}

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>7. 未成年の利用について</Text>
            <Text style={styles.paragraph}>
              未成年のユーザーが本アプリを利用する場合、保護者または学校等の管理者の同意・指導のもとで利用することを想定しています。
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>8. ポリシーの変更</Text>
            <Text style={styles.paragraph}>
              本ポリシーは、法令やサービス内容の変更に応じて改定することがあります。重要な変更がある場合は、アプリ内または本ページでお知らせします。
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>9. お問い合わせ</Text>
            <Text style={styles.paragraph}>
              個人情報の取り扱いに関するお問い合わせは、info@upsee.jp までご連絡ください。
            </Text>
          </View>
        </View>

        <View style={styles.footer}>
          <Link href={"/marketing" as never} style={styles.link}>
            学問レンズについて
          </Link>
          <Text style={styles.footerText}>© 2026 Upsee Inc. 学問レンズ</Text>
        </View>
      </ScrollView>
    </>
  );
}

const styles = StyleSheet.create({
  page: {
    flex: 1,
    backgroundColor: "#f8fafc",
  },
  content: {
    alignItems: "center",
    paddingBottom: 44,
  },
  header: {
    width: "100%",
    maxWidth: 860,
    paddingHorizontal: 24,
    paddingTop: 56,
    paddingBottom: 28,
  },
  kicker: {
    color: "#116466",
    fontSize: 16,
    fontWeight: "800",
    marginBottom: 10,
  },
  title: {
    color: "#111827",
    fontSize: 36,
    lineHeight: 46,
    fontWeight: "800",
    marginBottom: 10,
  },
  updated: {
    color: "#6b7280",
    fontSize: 14,
    marginBottom: 18,
  },
  lead: {
    color: "#4b5563",
    fontSize: 16,
    lineHeight: 28,
  },
  policy: {
    width: "100%",
    maxWidth: 860,
    paddingHorizontal: 24,
  },
  section: {
    borderTopWidth: 1,
    borderTopColor: "#dfe7ef",
    paddingVertical: 22,
  },
  sectionTitle: {
    color: "#111827",
    fontSize: 20,
    fontWeight: "800",
    marginBottom: 10,
  },
  paragraph: {
    color: "#374151",
    fontSize: 15,
    lineHeight: 26,
    marginBottom: 8,
  },
  footer: {
    width: "100%",
    maxWidth: 860,
    paddingHorizontal: 24,
    paddingTop: 12,
    gap: 12,
  },
  link: {
    color: "#116466",
    fontWeight: "800",
  },
  footerText: {
    color: "#6b7280",
    fontSize: 13,
  },
});
